import {
  addIds,
  ALL_SHARD_MODULES,
  formatQuery,
  getTranslatedText,
  QueryBuilder,
  renamePropertyInRuleGroup,
  COMMON_CONSTANTS,
  checkInactiveField
} from '@nile/components';
import {
  AccountClient,
  apiMethodAndKeyNames,
  apiResolver,
  GET_FIELD,
  GET_REQUESTERS_BY_CRITERIA,
  GET_TECHNICIANS_BY_CRITERIA,
  TicketClient
} from '@nile/graphql';
import { cloneDeep, includes } from 'lodash';
import nanoid from 'nanoid';
import React, { Component, useEffect, useState } from 'react';
import { injectIntl } from 'react-intl';
import * as _ from 'lodash';

class EventRuleBuilder extends Component {
  render() {
    return (
      // <div>Coming soon..</div>
      <RuleBuilder {...this.props} />
    );
  }
}

function RuleBuilder(props) {
  const appendProperties = (query) => {
    query = renamePropertyInRuleGroup(query, 'joinOperator', 'combinator');
    query = renamePropertyInRuleGroup(query, 'attribute', 'field');
    query = renamePropertyInRuleGroup(query, 'operands', 'rules');
    query = addIds(query);
    return query;
  };
  let inputQuery = cloneDeep(props.query);
  if (inputQuery) {
    inputQuery = appendProperties(inputQuery);
  }

  let preparedQueries = inputQuery || {
    id: `g-${nanoid()}`,
    rules: [],
    combinator: 'AND',
    not: false
  };
  let preparedFields = [];
  const operatorComponentMap = {
    is: 'select',
    isNot: 'select',
    isEmpty: null,
    isNotEmpty: null,
    startsWith: 'text',
    endsWith: 'text',
    contains: 'text',
    notContains: 'text',
    includes: 'multiselect',
    notIncludes: 'multiselect',
    greaterThan: 'text',
    greaterThanOrEqual: 'text',
    lessThan: 'text',
    lessThanOrEqual: 'text',
    on: 'date_options_select',
    between: 'dual_date_picker',
    inNext: 'unit',
    inLast: 'unit',
    notInLast: 'unit',
    after: 'datepicker',
    before: 'datepicker'
  };
  const [query, setQuery] = useState(preparedQueries);
  const [fields, setFields] = useState([]);
  const [format, setFormat] = useState('json');
  const [allEntityFieldsMap, setEntityFieldMap] = useState({});
  const [entities, setEntities] = useState({});
  const context = props.context;
  const { allEntities, allOperators, meta, intl } = props;
  const processedOperators = cloneDeep(
    allOperators.getRuleBuilderOperators.operators
  );
  Object.keys(processedOperators).forEach((key) => {
    processedOperators[key] = getTranslatedText(intl, processedOperators[key]);
  });
  useEffect(() => {
    let parsedEntities = cloneDeep(allEntities);
    parsedEntities.getEntitiesMeta = parsedEntities.getEntitiesMeta.map(
      (metaEntity) => {
        return {
          ...metaEntity,
          attributes: metaEntity.attributes.map((field) => {
            return {
              ...field,
              label: getTranslatedText(intl, field.label || field.name)
            };
          })
        };
      }
    );
    preparedFields = parsedEntities
      ? parsedEntities.getEntitiesMeta
          .find((el) => el.name === 'Ticket')
          .attributes.filter((item) => {
            return meta.conditionAttributes.some((el) => el.name === item.name);
          })
      : [];
    let groupedFields = [];
    let entityFields = preparedFields.filter(
      (item) => item.dataType === 'entity'
    );
    let entityFieldSuggestedProperties = {};
    entityFieldSuggestedProperties = {};
    for (let i = 0; i < entityFields.length; i++) {
      let conditionField = meta.conditionAttributes.find(
        (el) => el.name === entityFields[i].name
      );
      let allowedFieldsForEntity = conditionField.fields;
      let ca = [];
      if (conditionField.allowInCondition) {
        const currentEntity = entityFields.find(
          (el) => el.name === conditionField.name
        );
        ca.push({
          value: currentEntity.name,
          label: getTranslatedText(intl, currentEntity.label),
          name: currentEntity.name
        });
      }
      for (let j = 0; j < allowedFieldsForEntity.length; j++) {
        let val = parsedEntities.getEntitiesMeta
          .find((el) => el.name === entityFields[i].entity)
          .attributes.find((arr) => {
            return arr.name === allowedFieldsForEntity[j].name;
          });
        if (val) {
          ca.push({
            ...val,
            label: getTranslatedText(intl, val?.attributePlaceHolder?.label),
            name: entityFields[i].name + '.' + val?.name
          });
        }
      }
      entityFieldSuggestedProperties[entityFields[i].name] = ca;
    }
    for (let prop in entityFieldSuggestedProperties) {
      preparedFields = preparedFields.concat(
        entityFieldSuggestedProperties[prop]
      );
    }
    entityFieldSuggestedProperties['ticket'] = parsedEntities.getEntitiesMeta
      .find((el) => el.name === 'Ticket')
      .attributes.filter((item) => {
        return (
          meta.conditionAttributes.some((el) => el.name === item.name) &&
          item.dataType !== 'entity'
        );
      });
    setEntityFieldMap(entityFieldSuggestedProperties);
    setFields(preparedFields);
    setEntities(parsedEntities);
  }, []);
  /**
   * Reloads a prepared query, a PoC for query updates by props change.
   * If no target is supplied, clear query (generic query).
   */

  const isRuleGroup = (ruleOrGroup) => {
    return !!(ruleOrGroup.combinator && ruleOrGroup.rules);
  };

  const findRule = (field, parent) => {
    if (parent.field === field) {
      return parent;
    }

    for (const rule of parent.rules) {
      if (rule.field === field) {
        return rule;
      } else if (isRuleGroup(rule)) {
        const subRule = findRule(field, rule);
        if (subRule) {
          return subRule;
        }
      }
    }
  };

  const deleteRule = (field, parent) => {
    for (let rule of parent.rules) {
      if (rule.field === field) {
        parent.rules = parent.rules.filter((item) => item.field !== field);
      } else if (isRuleGroup(rule)) {
        const subRule = deleteRule(field, rule);
        if (subRule) {
          return subRule;
        }
      }
    }
    return parent;
  };

  const handleQueryChange = (query) => {
    setQuery(query);
    const formattedRule = formatQuery(query, 'json');
    context.updateAutomationRule(formattedRule, 'ruleCondition');
  };

  const getOperators = (field) => {
    const selectedField = fields.find((el) => el.name === field);
    const operators = processedOperators;
    const operatorMap = allOperators.getRuleBuilderOperators.operatorType;
    // console.log('selectedField:: ', selectedField);
    if (
      selectedField &&
      Object.keys(selectedField).length &&
      selectedField.dataType !== 'entity'
    ) {
      const requiredOperators = _.pick(
        operators,
        operatorMap[selectedField.dataType]
      );
      let formattedOperatorValues = [];
      if (
        operatorMap?.[selectedField.dataType]?.findIndex(
          (el) => el === 'placeholders'
        ) > -1
      ) {
        const selectedFieldFromMeta = meta.conditionAttributes.find(
          (el) => el.name === selectedField.name
        );
        const metaPlaceholders = selectedFieldFromMeta.placeholders || [];
        formattedOperatorValues = metaPlaceholders.map((el) => {
          return {
            name: el,
            label: getTranslatedText(intl, el),
            type: 'placeholder'
          };
        });
        return formattedOperatorValues;
      }
      for (let prop in requiredOperators) {
        let _obj = {
          name: prop,
          label: requiredOperators[prop]
        };
        formattedOperatorValues.push(_obj);
      }
      return formattedOperatorValues;
    }
    if (selectedField?.dataType === 'entity') {
      let formattedOperatorValues = [];
      if (
        operatorMap?.[selectedField.dataType]?.findIndex(
          (el) => el === 'placeholders'
        ) > -1
      ) {
        const selectedFieldFromMeta = meta.conditionAttributes.find(
          (el) => el.name === selectedField.name
        );
        const metaPlaceholders = selectedFieldFromMeta.placeholders || [];
        formattedOperatorValues = metaPlaceholders.map((el) => {
          return {
            name: el,
            label: getTranslatedText(intl, el),
            type: 'placeholder'
          };
        });
        return formattedOperatorValues;
      }
    }
    return [];
  };

  const getGroupedFields = (fields) => {
    let groupedFields = [];
    for (let prop in allEntityFieldsMap) {
      groupedFields.push({
        label: prop + ' fields',
        options: allEntityFieldsMap[prop]
      });
    }
    return groupedFields;
  };

  const getValueEditorType = (field, operator) => {
    const selectedField = fields.find((el) => el.name === field);
    if (!operator) return null;
    if (
      includes(
        ['text', 'read_only', 'numeric', 'decimal'],
        selectedField?.filterType
      )
    ) {
      if (selectedField.dataType === 'datetime') {
        switch (operator) {
          case 'after':
          case 'before':
            return 'datetime_picker';
          case 'between':
            return 'dual_datatime_picker';
          default:
            break;
        }
      }
      if (selectedField.dataType === 'boolean') {
        switch (operator) {
          case 'is':
            return 'boolean_select';
          default:
            break;
        }
      }
      if (selectedField?.autoComplete) {
        switch (operator) {
          case 'is':
          case 'isNot':
            return 'search_select';
          case 'includes':
          case 'notIncludes':
            return 'multi_search_select';
          case 'isEmpty':
          case 'isNotEmpty':
            return null;
          case 'startsWith':
          case 'endsWith':
          case 'contains':
          case 'notContains':
            return 'text';
          default:
            return selectedField?.filterType || 'text';
        }
      }
      switch (operator) {
        case 'isEmpty':
        case 'isNotEmpty':
          return null;
        case 'on':
        case 'inNext':
        case 'inLast':
        case 'notInLast':
        case 'after':
        case 'before':
        case 'between':
          return operatorComponentMap[operator];
        case 'includes':
        case 'notIncludes':
          return 'multi_select_text';
        default:
          return 'text';
      }
    }
    if (selectedField?.dataType === 'datetime') {
      switch (operator) {
        case 'after':
        case 'before':
          return 'datetime_picker';
        case 'between':
          return 'dual_datatime_picker';
        default:
          break;
      }
    }
    if (selectedField?.autoComplete) {
      switch (operator) {
        case 'is':
        case 'isNot':
          return 'search_select';
        case 'includes':
        case 'notIncludes':
          return 'multi_search_select';
        case 'isEmpty':
        case 'isNotEmpty':
          return null;
        case 'startsWith':
        case 'endsWith':
        case 'contains':
        case 'notContains':
          return 'text';
        default:
          return selectedField?.filterType || 'text';
      }
    }
    return operatorComponentMap[operator];
  };

  const getInputType = (field, operator) => {
    const selectedField = fields.find((el) => el.name === field);
    if (!operator) return null;
    if (includes(['numeric', 'decimal'], selectedField?.filterType)) {
      return 'number';
    }

    return operatorComponentMap[operator];
  };

  function getQuery(item) {
    const entity = item?.name?.split('.')[0] || '';
    switch (entity) {
      case 'technician':
      case 'followers':
        return GET_TECHNICIANS_BY_CRITERIA;
      default:
        return GET_REQUESTERS_BY_CRITERIA;
    }
  }

  function getNameKey(item) {
    const entity = item?.split('.')[0] || '';
    switch (entity) {
      case 'technician':
      case 'followers':
        return 'getTechnicianList';
      default:
        return 'getRequesterList';
    }
  }

  function getPropValues(item, operator) {
    if (item?.name) {
      if (item.isCustom) {
        let module = 'ticket';
        let columnName = item?.columnName || item?.name;
        if (item.name.split('.')?.length > 1) {
          module = item.name.split('.').shift();
          columnName = item.name.split('.').pop();
        }
        return AccountClient.query({
          query: GET_FIELD,
          variables: {
            input: {
              columnName,
              entity: ALL_SHARD_MODULES?.[module || 'ticket']
            }
          }
        });
      }
      const query = apiResolver.Ticket[item.name]?.api;
      const client = apiResolver.Ticket[item.name]?.client;
      let variables = apiResolver.Ticket[item.name]?.variables || {};

      if (item.name === 'client.name') {
        variables = {
          listInfo: {
            sort: {
              attribute: 'name',
              order: 'ASC'
            }
          }
        };
      }
      if (query && client) {
        return client.query({
          query: query,
          variables: variables
        });
      }
      if (operator) {
        return allOperators.getRuleBuilderOperators.operator_placeholders[
          operator
        ].map((el) => {
          return {
            ...el,
            label: getTranslatedText(intl, el.key),
            value: getTranslatedText(intl, el.key),
            name: el.key
          };
        });
      }
      return {
        client: AccountClient,
        query: getQuery(item),
        variables: variables
      };
    }
    return {};
    //return response;
  }

  async function getValues(field, operator) {
    const selectedField = fields.find((el) => el.name === field);
    if (field.split('.')?.length > 1) {
      const ent = field.split('.')[0];
      // omit custom fields because they do not require entering few characters to filter search options
      if (
        ent !== 'techGroup' &&
        ent !== 'client' &&
        ent !== 'site' &&
        ent !== 'department' &&
        !selectedField?.isCustom
      )
        return getPropValues(selectedField);
    }
    if (selectedField?.dataType === 'boolean') {
      return [
        {
          name: 'true',
          label: 'true',
          value: true
        },
        {
          name: 'false',
          label: 'false',
          value: false
        }
      ];
    }
    const allValues = await getPropValues(selectedField, operator);
    let res = [];
    let dataToMap = [];
    const selectedFieldName = selectedField?.name;
    if (selectedFieldName) {
      let method = apiMethodAndKeyNames[selectedFieldName]?.method;
      const secondaryMethod =
        apiMethodAndKeyNames[selectedFieldName]?.secondaryMethod;
      const key = apiMethodAndKeyNames[selectedFieldName]?.key;
      const nestedKey = apiMethodAndKeyNames[selectedFieldName]?.nestedKey;

      if (secondaryMethod) {
        dataToMap = allValues.data[method]?.[secondaryMethod];
      } else if (operator === 'on') {
        dataToMap = allValues;
      } else {
        dataToMap = allValues.data[method];
      }

      if (!dataToMap && !method) {
        dataToMap = allValues.data?.getField?.options;
      }

      if (selectedField.nestedTo) {
        const nestedProp = apiMethodAndKeyNames[selectedFieldName]?.nestedKey;
        if (!nestedProp) {
          res = dataToMap?.map((c) => ({
            name: c[key || 'value'],
            value: c[key || 'value'],
            label: c[key || 'value']
          }));
        } else {
          dataToMap.forEach((el) => {
            if (el[[nestedProp]]) {
              res = res.concat(
                el[[nestedProp]].map((c) => {
                  return {
                    name: c?.[key],
                    value: c?.[key],
                    label: c?.[key]
                  };
                })
              );
            }
          });
        }
      } else if (selectedField.isCustom) {
        method = 'getField';
        const fldOptions =
          allValues?.data?.[method]?.options ||
          allValues?.data?.[method]?.fieldOptions;
        res = allValues.data
          ? fldOptions?.map((el) => {
              return {
                name: el?.value,
                value: el?.value,
                label: el?.value
              };
            })
          : [];
      } else if (operator === 'on') {
        res = allValues;
      } else if (nestedKey) {
        res = dataToMap?.[nestedKey]
          ? dataToMap?.[nestedKey].map((el) => {
              return {
                name: el[key],
                value: el[key],
                label: el[key]
              };
            })
          : [];
      } else {
        res = dataToMap
          ? dataToMap.map((el) => {
              return {
                name: el[key],
                value: el[key],
                label: el[key]
              };
            })
          : [];
      }
    }

    return res;
  }

  const fetchValues = async (client, query, params) => {
    // console.log('fetching values', client, query, params);
    const attribute = params?.field?.split('.')[1];
    const nameKey = getNameKey(params.field);
    const variables = {
      listInfo: {
        condition: {
          joinOperator: 'AND',
          operands: [
            {
              attribute: attribute || 'firstName',
              operator: 'startsWith',
              value: params.inputValue
            }
          ]
        }
      }
    };
    const res = await client.query({
      query: query,
      variables: COMMON_CONSTANTS.IS_INSIDE_INPUT_VARIABLES[nameKey]
        ? { input: variables }
        : variables
    });
    const allOptions = res?.data?.[nameKey]
      ? res.data[nameKey].userList.map((el) => {
          return {
            name: `${el[attribute]}`,
            value: `${el[attribute]}`,
            label: `${el[attribute]}`
          };
        })
      : [];

    // console.log(allOptions);
    return allOptions;
  };

  return (
    // <EventTriggerContext.Consumer>
    //   {(context) => (
    <div className="flex-box-outer" name={props.name}>
      <div className="flex-box">
        <div className="scroll">
          <QueryBuilder
            query={query}
            fields={fields}
            isFieldGrouped
            onQueryChange={handleQueryChange}
            getOperators={getOperators}
            getGroupedFields={getGroupedFields}
            getValueEditorType={getValueEditorType}
            getInputType={getInputType}
            getValues={async function(item, operator) {
              const result = await getValues(item, operator);
              return result;
            }}
            fetchValues={async function(client, query, params) {
              const result = await fetchValues(client, query, params);
              return result;
            }}
            showCombinatorsBetweenRules
            showNotToggle={false}
            resetOnFieldChange
            operatorComponentMap={operatorComponentMap}
            errors={props.errors}
            checkInactiveField={checkInactiveField({
              module: 'ticket',
              allEntities: allEntities,
              allOperators: allOperators,
              intl: intl
            })}
          />
        </div>
        {/* <pre>{formatQuery(query, format)}</pre> */}
      </div>
    </div>
    //   )}
    // </EventTriggerContext.Consumer>
  );
}

export default injectIntl(EventRuleBuilder);
